// extracted by mini-css-extract-plugin
module.exports = {"header":"custom_header__16wy8","fullWidth":"custom_fullWidth__1m-T1","collapseHeader":"custom_collapseHeader__WPJBO","description":"custom_description__1z5_h"};